import React from 'react';
import Breadcrumb from '../../components/common/Breadcrumb';
import { YMaps, Map } from '@pbe/react-yandex-maps';

export default function YandexMap() {

    return (
        <>
            <Breadcrumb title="Yandex Map" path="Charts / Yandex Map" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 mb-30'>
                <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                    Basic Example
                </p>
                <YMaps query={{ lang: 'en_US' }}>
                    <Map
                        className="w-full h-[500px]"
                        defaultState={{ center: [55.75, 37.57], zoom: 2 }}
                    />
                </YMaps>
            </div>
            {/* <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 mb-30'>
                <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                    Markers
                </p>
                <YMaps query={{ lang: 'en_US' }}>
                    <Map
                        className="w-full h-[500px]"
                        defaultState={{ center: [55.75, 37.57], zoom: 5 }}
                    >
                        <Placemark geometry={[55.751574, 37.573856]} />
                        <Placemark geometry={[58, 37.573856]} />
                        <Placemark geometry={[52.751574, 40]} />
                        <Placemark geometry={[53, 35]} />
                        <Placemark geometry={[51, 30]} />
                        <Placemark geometry={[55, 45]} />
                        <Placemark geometry={[55, 35]} />
                    </Map>
                </YMaps>
            </div> */}
            {/* <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15 mb-30'>
                <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
                    Polygon
                </p>
                <YMaps query={{ lang: 'en_US' }}>
                    <Map
                        className="w-full h-[500px]"
                        defaultState={{ center: [55.75, 37.57], zoom: 5 }}
                    >
                        <Polyline
                            geometry={[
                                [58, 37.573856],
                                [55, 45],
                                [52.751574, 40],
                                [53, 35],
                                [55, 35],
                                [58, 37.573856],
                            ]}
                            options={{
                                strokeColor: "#000",
                                strokeWidth: 4,
                                strokeOpacity: 0.5,
                            }}
                        />
                    </Map>
                </YMaps>
            </div> */}
        </>
    );
}
